import { ResponseError } from "@/types";

export class ErrorHelper {
  /**
   * Maps errors from backend response to ResponseError array
   * @param errors: object
   * @return ResponseError[]
   */
  public static mapResponseErrors(errors: object): ResponseError[] {
    const result: ResponseError[] = [];

    Object.entries(errors).forEach((error) => {
      result.push({
        field: error[0],
        message: error[1][0],
      });
    });

    return result;
  }
}
